import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5381741c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/styles/list.scss?vue&type=style&index=0&id=5381741c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381741c",
  null
  
)

export default component.exports